import { Component, Input, OnInit } from '@angular/core';

@Component({
  selector: 'header-title',
  templateUrl: './header-title.component.html',
  styleUrls: ['./header-title.component.css']
})
export class HeaderTitleComponent implements OnInit {

  constructor() { }
  @Input() headerTitle: string;
  @Input() headerTitleModal: string;
  ngOnInit(): void {
  }

}
